import { z } from '../zod.js';
import { WebhookSubscribableEventValidationEnum } from './enum.js';

export const WEBHOOK_MAX_CUSTOM_HEADERS = 10;

export const WebhookNameValidationSchema = z.string().trim().min(1).max(100).meta({
  description: 'Internal label for the endpoint, shown in the dashboard.',
  example: 'CRM sync',
});

// Mongoose trims `url` on save, so untrimmed input would slip past the
// duplicate-URL lookup and then be stored trimmed — two live webhooks on one URL.
export const WebhookUrlValidationSchema = z
  .url({ protocol: /^https$/, error: 'Webhook URL must use https' })
  .max(2048)
  .trim()
  .meta({
    description: 'The https URL Checkout Page POSTs event payloads to. Plain http is rejected.',
    example: 'https://example.com/hooks/checkoutpage',
  });

export const WebhookEventsValidationSchema = z
  .array(WebhookSubscribableEventValidationEnum)
  .min(1)
  .meta({
    description: 'Events this endpoint receives. At least one is required; duplicates are ignored.',
    example: ['payment.paid', 'subscription.created'],
  });

export const WebhookSecretValidationSchema = z.string().min(10).max(100).meta({
  description:
    'Secret used to sign deliveries (`X-Webhook-Signature`), 10–100 characters. Omit to have Checkout Page generate one. The API returns it only in the create response; it can be viewed or rotated later in the dashboard.',
});

export const WebhookCustomHeadersValidationSchema = z
  .record(z.string().min(1).max(100), z.string().max(1000))
  .refine(headers => Object.keys(headers).length <= WEBHOOK_MAX_CUSTOM_HEADERS, {
    message: `Cannot have more than ${WEBHOOK_MAX_CUSTOM_HEADERS} custom headers`,
  })
  .meta({
    description:
      'Extra HTTP headers sent with every delivery, for example an `Authorization` header your receiver expects. Maximum 10.',
    example: { Authorization: 'Bearer my-receiver-token' },
  });

export const WebhookCreateBodyValidationSchema = z.object({
  name: WebhookNameValidationSchema,
  url: WebhookUrlValidationSchema,
  events: WebhookEventsValidationSchema,
  secret: WebhookSecretValidationSchema.optional(),
  customHeaders: WebhookCustomHeadersValidationSchema.optional(),
});
